query MyPOStatusChartData {
  kpiMyPoStatuses(orderBy: ID_ASC) {
    nodes {
      title
      amount
      searchHint
    }
  }
}
